<template>
	<div class="home-course">
		<!-- 直播： -->
		<section class="video-live maxW" ref="liveFloor">
			<div class="live-banner clear">
				<div class="video-play-cont fl">
					<!-- 视频播放器 -->
					<liveVideo v-if="videoShowFlag==true" :playParam.sync="playParam"></liveVideo>
					<div class="no-live" v-else></div>
				</div>
				<div class="video-winndow fr">
					<ul class="video-ul">
						<template v-for="(item,index) of livePicData">
							<li class="video-li" :key="index" v-if="index<3">
								<router-link :to="{path: '/home/openclassDetail', query: {id: item.id}}">
									<img :src="BASE_URL+item.picture" />
								</router-link>
							</li>
						</template>
					</ul>
				</div>
			</div>
			<div class="vStatus-content">
				<div class="vStatus-title clear">
					<div class="titleNav clear">
						<div class="titleNav-l fl">
							<span type="text" :class="[vStatus=='living'? 'blueC':'']" @click="toggleStatus(2,null)">{{$t('homepage.living')}}</span>
							<span type="text" :class="[vStatus=='notStarted'? 'blueC':'']" @click="toggleStatus(1,null)">{{$t('homepage.notStart')}}</span>
						</div>
						<div class="titleNav-r fr">
							<el-date-picker v-model="liveDate" type="date" clearable :placeholder="'-'+$t('global.selectDate')+'-'" @change="toggleStatus(2,liveDate)"></el-date-picker>
							<i class="ipng but_Date01_up"></i>
						</div>
					</div>
					<ul class="hot_video clear">
						<li class="i_hotList wow bounceInLeft fl" v-for="(item,index) of liveData" :key="index">
							<router-link :to="{path: '/home/liveRoom', query: {id: item.id}}">
								<img :src="BASE_URL + item.picture" />
							</router-link>
							<router-link :to="{path: '/home/liveRoom', query: {id: item.id}}" :title="item.name" class="i_ellipsis">{{item.name}}</router-link>
							<div class="i_hotType clear">
								<router-link :to="{path: '/teach/space', query: {id: item.create_id}}">
									<span>
										<img :src="BASE_URL + item.avatar_path" />
									</span>
									{{item.teachername}}
								</router-link>
								<a href="javascript:;">{{item.time_string}}</a>
							</div>
						</li>
						<div class="noDataTip" v-if="liveData.length==0">没发现直播数据哦~</div>
					</ul>
				</div>
			</div>
		</section>
		<!-- 公开课： -->
		<section class="open-class maxW" ref="openclassFloor">
			<div class="bgc-img">
				<img src="../../../../public/images/image04 (1).png" alt="标语" />
			</div>
			<div class="i_applicationTitle">
				<span>
					公开课
					<i>推荐</i>
				</span>
			</div>
			<div class="openClass-list">
				<ul class="clear">
					<li class="openClass-li fl clear" v-for="(item,index) of openClassData" :key="index">
						<div class="openClass-view fl">
							<img :src="imgsData[index]" />
							<span>{{item.name}}专区</span>
						</div>
						<div class="openClass-txt fl">
							<div class="openClass-title clear">
								<span>共{{item.video_data.data_sum}}个课程</span>
								<router-link to="/home/openclassList" target="_blank" rel="noopener noreferrer">
									更多
									<i class="ipng Shape_13"></i>
								</router-link>
							</div>
							<div class="openClass-cont">
								<ul>
									<li class="openClass-ls clear" v-for="(item1,index1) of item.video_data.data" :key="index1">
										<router-link :to="{path: '/home/openclassDetail', query: {id: item1.id}}" target="_blank" rel="noopener noreferrer">{{item1.video_name}}</router-link>
										<span>
											<i class="ipng playi"></i>
											{{item1.clicks}}
										</span>
										<router-link :to="{path: '/home/openclassDetail', query: {id: item1.id}}" class="video-view" target="_blank"
										 rel="noopener noreferrer">
											<img :src="BASE_URL+item1.picture" />
										</router-link>
									</li>
									<div class="no-data-tip" v-if="item.video_data.data_sum==0">
										<span>- 暂无课程 -</span>
									</div>
								</ul>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</section>
		<div class="i_floorBox">
			<a :class="floorActive==0?'i_floor clear i_active':'i_floor clear'" href="javascript:;" @click="toTop(0)">
				<span>直播</span>
				<i class="ipng Shape_13"></i>
			</a>
			<a :class="floorActive==1?'i_floor clear i_active':'i_floor clear'" href="javascript:;" @click="toTop(1)">
				<span>公开课</span>
				<i class="ipng Shape_13"></i>
			</a>
		</div>
	</div>
</template>

<script>
	import liveVideo from "@/components/common/liveVideo";
	export default {
		components: {
			liveVideo
		},
		data() {
			return {
				// 滑动页面对应的位置：
				floorActive: 0,
				floorInterval: null,
				scrollTop: 0,
				//视频：
				videoShowFlag: false, //默认不显示视频
				playParam: {
					play_url: "1111"
				},
				showBgPic: false, //没有直播时，展示一个背景图
				livingData: [],
				vStatus: "living",
				liveDate: "",
				livePicData: [],
				liveData: [], //直播中/未开始/选日期
				live_page_max: 0,
				// 公开课：
				openClassData: [],
				imgsData: [
					require("../../../assets/images/course_cate_00.png"),
					require("../../../assets/images/course_cate_01.png"),
					require("../../../assets/images/course_cate_02.png"),
					require("../../../assets/images/course_cate_03.png")
				]
			};
		},
		created() {
			this.getLive();
			this.getLivePic();
			this.toggleStatus(2, null);
			this.getOpenClass();
		},
		methods: {
			// 跳到相应楼层
			toTop(num) {
				this.floorActive = num;
				let distance = 0;
				let step = 20;
				if (num == 0) {
					distance = this.$refs.liveFloor.offsetTop - 25;
				} else if (num == 1) {
					distance = this.$refs.openclassFloor.offsetTop;
				}
				this.floorInterval = setInterval(() => {
					if (distance > this.scrollTop) {
						this.scrollTop += step;
					} else {
						this.scrollTop -= step;
					}
					document.documentElement.scrollTop = this.scrollTop;
					if (Math.abs(distance - this.scrollTop) < step) {
						this.scrollTop = distance;
						clearInterval(this.floorInterval);
					}
				}, 5);
			},
			//获取 直播列表0 或 视频列表1
			getTheList(_params, type) {
				let _url = "";
				let result;
				type == 0 ?
					(_url = "api/live/live_list") :
					(_url = "api/video/video_list");
				let success = res => {
					result = res;
				};
				this.$ajax({
					url: _url,
					method: "get",
					params: _params,
					func: {
						success: success
					}
				});
				return result;
			},
			// 获取直播
			getLive() {
				let success = res => {
					if (res.data.data != "") {
						this.videoShowFlag = true; //显示视频播放器
						this.playParam.play_url = res.data.data[0].rtmp; //赋值播放流地址
					} else {
						this.showBgPic = true;
					}
				};
				this.$ajax({
					url: "api/live/live_list",
					method: "get",
					params: {
						page_index: 1,
						page_size: 1,
						live_type: 2
					},
					func: {
						success: success
					}
				});
			},
			// 直播窗口右边的小橱窗照片
			getLivePic() {
				let success = res => {
					this.livePicData = res.data.data;
				};
				this.$ajax({
					url: "api/video/video_list",
					method: "get",
					params: {
						page_index: 1,
						page_size: 6,
						authority: 1,
						status: 1
					},
					func: {
						success: success
					}
				});
			},
			//直播中live_type2  未开始live_type1  日期live_type2
			toggleStatus(_type, _data) {
				if (_type == 2 && _data == null) {
					this.vStatus = "living";
				} else if (_type == 1 && _data == null) {
					this.vStatus = "notStarted";
				}
				let success = res => {
					this.liveData = res.data.data;
					this.live_page_max = res.data.page_max;
				};
				this.$ajax({
					url: "api/live/live_list",
					method: "get",
					params: {
						page_index: 1,
						page_size: 4,
						live_type: _type,
						keyword: null,
						date: _data
					},
					func: {
						success: success
					}
				});
			},

			// 获取公开课数据
			getOpenClass() {
				let success = res => {
					this.openClassData = res.data;
					let _data = deep_clone(res.data);
					for (var i = 0; i < _data.length; i++) {
						this.openClassData[i].video_data = {};
						this.getVideoList(i, _data[i].id);
					}
				};
				this.$ajax({
					url: "api/org/org",
					method: "get",
					params: {
						status: 1,
						level: 2
					},
					func: {
						success: success
					}
				});
			},
			// 根据专区的id获取对应的视频数据
			getVideoList(inx, _id) {
				let success = res => {
					this.$set(this.openClassData[inx], "video_data", res.data);
					this.$forceUpdate();
				};
				this.$ajax({
					url: "api/video/video_list",
					method: "get",
					params: {
						page_index: 1,
						page_size: 6,
						study_section_id: _id,
						authority: 1,
						status: 1,
						order_type: "click"
					},
					func: {
						success: success
					}
				});
			}
		}
	};
</script>
